export default __webpack_public_path__ + "static/netlify-007635b3c5388bf3c7ed1eb8ec7b63e3.svg";